import { IPlan, ITask, TScoreData } from "../../../../../common/types";

export default (plan: IPlan, task: ITask) => {
    let scale = (task.data as TScoreData).scale;
    if (!scale) {
        if (task.ref) {
            scale = plan.scores.find(s => s._id.toString() === task.ref!.toString())!.scale || 1;
        } else {
            scale = 1;
        }
    }
    return scale;
};
